// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"Tooltip_Tooltip__1_-TX","Tooltip--light":"Tooltip_Tooltip--light__3s-Dl","Tooltip--dark":"Tooltip_Tooltip--dark__3y0O5"};